import { observable, action } from "mobx";
import axios from "axios";

export default class FormStore {
    @observable submitted;
    @observable submitMensagemErro;
    @observable acaoEnviada;
    @observable solicitando;
    @observable nomeAcao;


    constructor() {
        this.acaoEnviada = false;
        this.submitted = false;
        this.submitMensagemErro = "";
        this.solicitando = false;
        this.nomeAcao = null;
    }


    toggleAcaoEnviada() {
        this.acaoEnviada = !this.acaoEnviada;
    }

    setSubmitted(value) {
        this.submitted = value;
    }

    setSubmitMensagemErro(value) {
        this.submitMensagemErro = value;
    }

    setNomeAcao(value) {
        this.nomeAcao = value;
    }
}
